module.exports = __webpack_public_path__ + "cceb0805159141b1af21b24521f6ff1b.svg";